import {IconButton, Stack} from "@mui/material";
import CallIcon from "@mui/icons-material/Call";
import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import ScrollAnimation from "react-animate-on-scroll";

const SocialMenu = (props) => {
    const iconColor = props.iconColor || '';
    const iconSize = props.iconSize || 40;
    const iconAlwaysVisible = props.noAnimation || false;

    const facebookClickListener = () => {
        var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if (isMobile) {
            window.location = "fb://profile/100084507589138";
        } else {
            window.open("https://www.facebook.com/profile.php?id=100084507589138",  '_blank');
        }
    }
    const instagramClickListener = () => {
        var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if (isMobile) {
            window.location = "instagram://user?username=labruschetta07072011";
        } else {
            window.open("https://www.instagram.com/labruschetta07072011/",  '_blank');
        }
    }

    return <Stack sx={props.sx} direction='row' alignItems='center' justifyContent='center'>
        <ScrollAnimation animateIn='zoomIn' initiallyVisible={iconAlwaysVisible}>
            <a href={'tel:3396789081'} rel='noreferrer' target={'_blank'}>
                <IconButton  size='large' aria-label='Chiamaci'>
                    <CallIcon sx={{color: iconColor, fontSize: iconSize}}/>
                </IconButton>
            </a>
        </ScrollAnimation>
        <ScrollAnimation animateIn='zoomIn' delay={50} initiallyVisible={iconAlwaysVisible}>
            <div onClick={facebookClickListener}>
                <IconButton  size='large' aria-label='Facebook'>
                    <FacebookIcon sx={{color: iconColor, fontSize: iconSize}}/>
                </IconButton>
            </div>
        </ScrollAnimation>
        <ScrollAnimation animateIn='zoomIn' delay={100} initiallyVisible={iconAlwaysVisible}>
            <div onClick={instagramClickListener}>
                <IconButton size='large' aria-label='Instagram'>
                    <InstagramIcon sx={{color: iconColor, fontSize: iconSize}} />
                </IconButton>
            </div>
        </ScrollAnimation>
        <ScrollAnimation animateIn='zoomIn' delay={150} initiallyVisible={iconAlwaysVisible}>
            <a href={'https://wa.me/3396789081'} rel='noreferrer' target={'_blank'}>
                <IconButton  size='large' aria-label='Whatsapp'>
                    <WhatsAppIcon sx={{color: iconColor, fontSize: iconSize}}  />
                </IconButton>
            </a>
        </ScrollAnimation>

    </Stack>
}

export default SocialMenu;